// Default theme
import "@splidejs/react-splide/css";

// or other themes
//import '@splidejs/react-splide/css/skyblue';
//import '@splidejs/react-splide/css/sea-green';

// or only core styles
import "@splidejs/react-splide/css/core";
//import './components/hero/style.scss';

import SFUseStyled from "./hooks/useStyled";
import SFUseWindowSize from "./hooks/useWindowSize";
import UserService from "./services/userService";
import SFResponsive, {
  isResponsiveSize as SFisResponsiveSize,
  isResponsiveSizeUp as SFisResponsiveUp,
  isResponsiveSizeDown as SFisResponsiveDown,
  getCurrentBreakpoint as SFgetCurrentBreakpoint,
} from "./components/responsive";
import { userDetailsActions as SFUserDetailsActions } from "./redux/reducers/userReducer";
import * as SFIcons from "./components/icons";
import SFHaloIconWrapper from "./components/icons/halo";
import {
  SFButton,
  SFIconButton,
  SFLoadingButton,
  SFButtonGroup,
} from "./components/buttons";
import SFTypography from "./components/typography";
import {
  SFStack,
  SFGrid,
  SFGridContainer,
  SFGridItem,
  SFGridContainerItem,
  SFGridRemoveGutters,
} from "./components/grid";
import SFPageContainer, {
  SFContentContainer,
} from "./components/pageContainer";
import SFPageFloatContainer from "./components/pageFloatContainer";
import SFLink from "./components/link";
import {
  SFLoadingBar,
  SFLoadingScreen,
  SFLoadingPage,
  SFLoadingSpinner,
} from "./components/loading";

import SFAppBar from "./components/appBar";
import SFSkeleton from "./components/skeleton";

import SFThemeProvider from "./themeProvider";
import useSFAnimation from "./components/animation";

import SFLanguages from "./languages";
import * as SFAnimationAssets from "./components/animationAssets";
import SFCoreReducers from "./redux/reducers";

import { gridLayoutActions as SFGridLayoutActions } from "./redux/reducers/gridLayoutReducer";
import { clientSideFilterActions as SFClientSideFilterActions} from "./redux/reducers/clientSideFilterReducer";

import { SFHeroContainer, SFHeroSlide } from "./components/hero";
import {
  SFCarouselTitle,
  SFCarouselContainer,
  SFCarouselSlide,
} from "./components/carousel";

import {
  SFVideoThumbnail,
  SFBaseThumbnail,
  SFSlideThumbnail,
} from "./components/thumbnails";

import SFProgress, { SFProgressBar } from "./components/progress";

import { SFTabs, SFTabsVertical, SFTabPanel } from "./components/tabs";
import { SFContent } from "./components/content";

import * as SFHelpers from "./utils";
import SFDivider from "./components/divider";

import SFDialog from "./components/dialog";
import SFRating from "./components/rating";
import SFDropdown from "./components/dropDown";
import SFMoreMenu from "./components/moreMenu";
import {
  getUtcDateTime,
  getAllMonths,
  getLongDate,
} from "./services/dateService";

import SFToggleButtons, { SFToggleButton } from "./components/toggleButton";
import SFTextField from "./components/textField";

import SFLottieAnimation from "./components/lottie";
import SFAvatar from "./components/avatar";
import SFDataGrid from "./components/dataGrid";
import SFBadge from "./components/badge";
import SFDrawer from "./components/drawer";
import SFAccordion, {
  SFAccordionDetails,
  SFAccordionSummary,
} from "./components/accordion";
import { HighlightText } from "./helpers/highlightText";
import SFBadgeIcons from "./components/badgeIcon";
import SFPillStepper from "./components/pillStepper";
import SFAreaChart from "./components/charts/area";
import { Colors } from "./constants/colors";
import { SFSkeletonThumbnail } from "./components/thumbnails";
import SFAvatarMenu from "./components/avatarMenu";
import ToastContainer from "./components/toast";

import { notificationActions } from "./redux/reducers/notificationReducer";
import { getNotifications } from "./services/notificationService";
import {
  Notification_Types,
  Notification_Actions,
} from "./constants/notificationTypes";

import SFCard from "./components/card";
import SFHeroCard, {
  SFHeroTile,
  SFProfileTile,
  SFDetailTile,
} from "./components/card/heroCard";
import SFEmptyPlaceholder from "./components/emptyPlaceholder";
import SFFatalError from "./components/fatalError";

const SFUserService = new UserService();

export {
  //Assets
  SFThemeProvider,
  SFLanguages,
  SFAnimationAssets,

  //Hooks
  SFUseWindowSize,
  SFUseStyled,
  SFCoreReducers,
  SFGridLayoutActions,
  SFClientSideFilterActions,

  //Services
  SFUserService,
  SFUserDetailsActions,
  getUtcDateTime,
  getAllMonths,
  getLongDate,
  getNotifications,
  notificationActions,

  //Helpers
  SFHelpers,

  //Constants
  Colors,
  Notification_Types,
  Notification_Actions,

  //Components
  SFAppBar,
  SFPageContainer,
  SFPageFloatContainer,
  SFResponsive,
  SFisResponsiveSize,
  SFisResponsiveUp,
  SFisResponsiveDown,
  SFgetCurrentBreakpoint,
  SFIcons,
  SFHaloIconWrapper,
  SFButton,
  SFIconButton,
  SFLoadingButton,
  SFButtonGroup,
  SFTypography,
  SFStack,
  SFGrid,
  SFGridContainer,
  SFGridItem,
  SFGridContainerItem,
  SFContentContainer,
  SFGridRemoveGutters,
  SFLoadingBar,
  SFLoadingSpinner,
  SFLoadingScreen,
  SFLoadingPage,
  SFLink,
  useSFAnimation,
  SFHeroContainer,
  SFHeroSlide,
  SFCarouselContainer,
  SFCarouselSlide,
  SFCarouselTitle,
  SFProgress,
  SFProgressBar,
  SFSkeleton,
  SFTabs,
  SFTabsVertical,
  SFTabPanel,
  SFContent,
  SFVideoThumbnail,
  SFBaseThumbnail,
  SFSlideThumbnail,
  SFDivider,
  SFDialog,
  SFToggleButtons,
  SFToggleButton,
  SFDropdown,
  SFMoreMenu,
  SFRating,
  SFTextField,
  SFLottieAnimation,
  SFDataGrid,
  SFAvatar,
  SFBadge,
  SFDrawer,
  SFAccordion,
  SFAccordionDetails,
  SFAccordionSummary,
  HighlightText,
  SFBadgeIcons,
  SFPillStepper,
  SFAreaChart,
  SFSkeletonThumbnail,
  SFAvatarMenu,
  ToastContainer,
  SFCard,
  SFHeroCard,
  SFHeroTile,
  SFProfileTile,
  SFDetailTile,
  SFEmptyPlaceholder,
  SFFatalError,
};
